<div class="ui-g">
  <div class="ui-g-12" style="position: relative">
    <div class="card card-w-title">
      <h1>Invoices</h1>

      <div class="ui-g">
        <div class="ui-g-8 ui-sm-12">
          <div>Engineius can generate invoices for you.</div>
          <br />
          <div>
            By agreeing to us producing your invoice, it removes the work you would need to do
            creating your invoices and submitting them to us for payment.
          </div>
          <br />
          <div>
            We will automatically generate them on the agreed schedule, and then automatically pay
            them the same day.
          </div>
          <br />
          <div>
            You can view and download the invoices at any time directly from the system. You can use
            these directly in your accounts.
          </div>
          <br />
          <div>We will reconfirm this with you each year.</div>
        </div>
        <div class="ui-g-4 ui-sm-12">
          <div class="self-billing-invoice-image"></div>
        </div>
      </div>

      <div class="ui-g">
        <div class="ui-g-12">
          <h1 style="padding-top: 3pt; text-indent: 0pt">Self Billing Agreement</h1>
          <h2 style="padding-top: 10pt; padding-left: 8pt; text-indent: 0pt; text-align: left">
            This is an agreement to a self-billing procedure between
          </h2>
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p style="text-indent: 0pt; text-align: left"></p>
          <p style="text-indent: 0pt; text-align: left"></p>

          <table style="width: 100%" cellspacing="7">
            <tr>
              <td style="width: 1%; white-space: nowrap">Customer name</td>
              <td class="data-box">Vehicle Movement Exchange</td>
              <td style="width: 1%; white-space: nowrap">VAT Number</td>
              <td class="data-box">244170234</td>
            </tr>
            <tr>
              <td colspan="4">and</td>
            </tr>
            <tr>
              <td style="width: 1%; white-space: nowrap">Supplier name</td>
              <td class="data-box">{{ currentUser.firstName }} {{ currentUser.lastName }}</td>
              <td style="width: 1%; white-space: nowrap">VAT Number</td>
              <td class="data-box">
                <span *ngIf="!loading && userOrg != null">{{ userOrg.vatNumber }}</span>
                <span *ngIf="loading" style="font-size: 1.15em"
                  ><i class="fa fa-spinner fa-spin"></i
                ></span>
              </td>
            </tr>
          </table>

          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p style="padding-top: 4pt; padding-left: 8pt; text-indent: 0pt; text-align: left">
            The self-biller (the customer) agrees:
          </p>
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <ol id="l1">
            <li data-list-text="1.">
              <p style="padding-left: 21pt; text-indent: -13pt; text-align: left">
                To issue self-billed invoices for all supplies made to them by the self-billee (the
                supplier) until
                <span
                  class="s1"
                  style="padding-top: 6pt; padding-left: 8pt; text-indent: 0pt; text-align: left"
                  >{{ agreementDate | datex : 'ddd DD MMM YYYY' }}</span
                >
              </p>
            </li>
            <li data-list-text="2.">
              <p
                style="
                  padding-top: 9pt;
                  padding-left: 8pt;
                  text-indent: 0pt;
                  line-height: 125%;
                  text-align: left;
                "
              >
                To complete self-billed invoices showing the supplier’s name, address and VAT
                registration number, together with all the other details which constitute a full VAT
                invoice.
              </p>
            </li>
            <li data-list-text="3.">
              <p style="padding-top: 5pt; padding-left: 21pt; text-indent: -13pt; text-align: left">
                To make a new self-billing agreement in the event that their VAT registration number
                changes.
              </p>
            </li>
            <li data-list-text="4.">
              <p style="padding-top: 9pt; padding-left: 21pt; text-indent: -13pt; text-align: left">
                to inform the supplier if the issue of self-billed invoices will be outsourced to a
                third party.
              </p>
            </li>
          </ol>
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p style="padding-left: 8pt; text-indent: 0pt; text-align: left">
            The self-billee agrees:
          </p>
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <ol id="l2">
            <li data-list-text="1.">
              <p style="padding-left: 8pt; text-indent: 0pt; text-align: left">
                To accept invoices raised by the self-biller on their behalf until
                <span
                  class="s1"
                  style="padding-top: 6pt; padding-left: 8pt; text-indent: 0pt; text-align: left"
                  >{{ agreementDate | datex : 'ddd DD MMM YYYY' }}</span
                >
              </p>
            </li>
            <li data-list-text="2.">
              <p style="padding-top: 8pt; padding-left: 21pt; text-indent: -13pt; text-align: left">
                Not to raise sales invoices for the transactions covered by this agreement.
              </p>
            </li>
            <li data-list-text="3.">
              <p style="padding-top: 9pt; padding-left: 21pt; text-indent: -13pt; text-align: left">
                To notify the customer immediately if they
              </p>
              <ul id="l3">
                <li data-list-text="•">
                  <p style="padding-left: 29pt; text-indent: -7pt; text-align: left">
                    change their VAT registration number
                  </p>
                </li>
                <li data-list-text="•">
                  <p style="padding-left: 29pt; text-indent: -7pt; text-align: left">
                    cease to be VAT registered, or
                  </p>
                </li>
                <li data-list-text="•">
                  <p style="padding-left: 29pt; text-indent: -7pt; text-align: left">
                    sell their business or part of their business
                  </p>
                </li>
              </ul>
            </li>
          </ol>
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p style="text-indent: 0pt; text-align: left"><br /></p>
        </div>
      </div>

      <div class="ui-g-12" style="margin-top: 50px">
        <div class="ui-g-12">
          <p-checkbox
            [(ngModel)]="agreeChecked"
            binary="true"
            label="I agree to Engineius creating invoices on my behalf"
            name="isAgreed"
          ></p-checkbox>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-12">
          <button
            (click)="confirm(true)"
            [disabled]="sendingCommit || !agreeChecked"
            class="green-btn"
            icon="fa ui-icon-check"
            label="Agree"
            pButton
            type="button"
          ></button>
          <button
            (click)="confirm(false)"
            class="red-btn"
            label="Reject"
            pButton
            style="margin-left: 20px"
            type="button"
          ></button>
          <button
            (click)="goBack()"
            *ngIf="backTo"
            label="Back"
            pButton
            style="margin-left: 20px"
            type="button"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>
